export enum StakingTypes {
  FLEXIBLE= 'FLEXIBLE',
  FIXED= 'FIXED',
}

export enum StakingAction {
  UPGRADE= 'UPGRADE',
  STAKE= 'STAKE',
}
